import React from 'react';
import { IFlexColumnListItem } from './IFlexColumnListItem';
import { ColumnHeader, ContainerHeader } from './styles';

interface IFlexColumnListHeaderProps {
  name: string;
  columns: IFlexColumnListItem[];
  loading?: boolean;
}

export const FlexColumnListHeader: React.FC<IFlexColumnListHeaderProps> = ({
  name,
  columns,
  loading
}) => {

  //if (loading) return null;

  return (
    <ContainerHeader data-class='FlexColumnListHeader'>
      {columns?.map((column, index) => {
        const dataKey = `${name}_header_${index}_${column.field}`;
        if (column.field === '_') {
          return (
            <div 
              data-class='ColumnHeader' key={dataKey} data-key={dataKey}
              style={{
                width: column.width,
                minWidth: column.width,
                maxWidth: column.width,
                background: '#F3F4F5',
                padding: '6px 0px'
              }}
            >&nbsp;</div>
          )
        }
        return (
          <ColumnHeader data-class='ColumnHeader' key={dataKey} data-key={dataKey} width={column.width} textAlign={column.align}>
            {column.title}
          </ColumnHeader>
        );
      })}
    </ContainerHeader>
  );
}